import { apiProxyRequest } from "Api/apiProxyRequest";

export const updateProfilePictureRequest = (
  userId: string,
  picture: FormData
) =>
  apiProxyRequest<{ url: string }>(
    `/profile/${userId}/picture`,
    "POST",
    picture
  );
